import {Box, Button} from '@material-ui/core'
import {Circular as CircularLoading, ProposalLogo} from 'app/components'
import Status from 'app/components/proposal/Status'
import Type from 'app/components/proposal/Type'
import {useFavorite, useUpdateOpportunity} from 'app/hooks'
import _t, {_} from 'i18n'
import React from 'react'
import {AlertTriangle, CheckCircle, Hash, Link, User} from 'react-feather'

import {DetailContainer, FavoriteIcon, Paper} from '../styles'
import BottomDetailIcons from './BottomDetailIcons'

const BasicProposalInfo = ({
  id,
  name,
  description,
  lost_at,
  completed_at,
  status,
  type,
  city,
  customer,
  is_favorite,
  logoUrl = '',
  project,
  ...rest
}) => {
  const {action: handleFavoriteOpportunity, loading: loadingFavorite, isFavorite} = useFavorite({
    id,
    is_favorite,
    entity: 'proposal',
    label: _`Proposta`,
  })

  const {action: handleOpportunityStatus, loading: loadingUpdate} = useUpdateOpportunity({
    id,
    status,
    callback: () => window.location.reload(),
  })

  return (
    <Paper>
      {status === 'pending' && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: '#FFD700',
            borderRadius: '4px 4px 0 0',
            color: '#000',
            fontSize: '14px',
            padding: '8px 16px',
            marginBottom: '16px',
            width: '100%',
          }}>
          <AlertTriangle size={20} style={{marginRight: '8px'}} />
          <span>
            {_`Esta oportunidade foi cadastrada através da vitrine e precisa ser analisada e aprovada para ser exibida.`}
          </span>
        </Box>
      )}
      <DetailContainer>
        <div className="d-flex justify-content-between mb-8">
          <div className="d-flex justify-content-start">
            <ProposalLogo borderRadius="50%" name={name} url={logoUrl} showFirstLetter height="92px" width="92px" />
            <div className="ml-4" style={{width: '100%', maxWidth: 570}}>
              <div className="d-flex align-items-top">
                <span className="title-proposal w-100">{name}</span>
                {loadingFavorite ? (
                  <CircularLoading />
                ) : (
                  <FavoriteIcon
                    aria-hidden="true"
                    className="fa fa-star"
                    isFavorite={isFavorite}
                    onClick={() => handleFavoriteOpportunity()}
                  />
                )}
              </div>
              <div className="w-100 mt-2">
                <ul className="proposal-links">
                  <li>
                    <Hash /> <span>{id}</span>
                  </li>
                  <li>
                    <User /> <span>{_t('Cadastrada por {{name}}', {name: customer.name})}</span>
                  </li>
                  {city ? (
                    <li>
                      <Link />{' '}
                      <span>
                        {_`Vinculada a`}{' '}
                        <a href={`/cities/${city.id}`}>
                          {city.name} - {city.state.uf}
                        </a>
                      </span>
                    </li>
                  ) : null}
                </ul>
              </div>
            </div>
          </div>
          <div className="d-flex w-25 align-items-center">
            <div className="w-50">
              <p className="secundary-title">{_`Tipo`}</p>
              {type && <Type type={type} width="36px" height="36px" iconSize="17px" />}
            </div>
            <div className="w-50">
              <p className="secundary-title">{_`Status`}</p>
              {status === 'pending' ? (
                loadingUpdate ? (
                  <CircularLoading />
                ) : (
                  <Button
                    variant="contained"
                    style={{backgroundColor: '#FFD700', color: '#000'}}
                    startIcon={<CheckCircle />}
                    onClick={() => handleOpportunityStatus()}>
                    {_`Aprovar e ativar`}
                  </Button>
                )
              ) : (
                <Status
                  status={status}
                  lg
                  width="36px"
                  height="36px"
                  iconSize="17px"
                  c
                  lostAt={lost_at}
                  completedAt={completed_at}
                />
              )}
            </div>
          </div>
        </div>
        <div className="w-100 mt-3">
          <p className="secundary-title">{_`Descrição`}</p>
          <p className="description-proposal">
            {description}
            {project?.description ? (
              <>
                <br /> {project.description}
              </>
            ) : null}
          </p>
        </div>
        <hr style={{marginTop: '2rem'}} />
        <BottomDetailIcons city={city} {...rest} />
      </DetailContainer>
    </Paper>
  )
}

export default BasicProposalInfo
